var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { staticClass: "form-channel-2" }, [
    _c(
      "div",
      { staticClass: "card-data" },
      [
        _c("create-circle", {
          attrs: {
            visible: _vm.addingCircle,
            "community-id": _vm.community_id
          },
          on: {
            "update:visible": function($event) {
              _vm.addingCircle = $event
            },
            save: _vm.onAddCircle,
            cancel: function($event) {
              _vm.addingCircle = false
            }
          }
        }),
        _vm._v(" "),
        _c(
          "md-dialog",
          {
            attrs: {
              "md-active": _vm.unsavedCircleDialogActive,
              "md-click-outside-to-close": false,
              "md-close-on-esc": false
            },
            on: {
              "update:mdActive": function($event) {
                _vm.unsavedCircleDialogActive = $event
              },
              "update:md-active": function($event) {
                _vm.unsavedCircleDialogActive = $event
              }
            }
          },
          [
            _c("md-dialog-title", [_vm._v("Unsaved circle changes")]),
            _vm._v(" "),
            _c("md-dialog-content", [
              _vm._v(
                "\n\t\t\t\tYou have unsaved changes. Do you want to save or discard them before switching circles?\n\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c(
              "md-dialog-actions",
              [
                _c(
                  "md-button",
                  { on: { click: _vm.discardPendingCircleChanges } },
                  [_vm._v("Discard")]
                ),
                _vm._v(" "),
                _c(
                  "md-button",
                  {
                    staticClass: "md-primary",
                    on: { click: _vm.savePendingCircleChanges }
                  },
                  [_vm._v("Save")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "md-list",
          { attrs: { "md-expand-single": _vm.expandSingle } },
          [
            _c(
              "md-list-item",
              [
                _c(
                  "md-button",
                  {
                    staticClass: "picker-icon picker-name",
                    on: {
                      click: function($event) {
                        _vm.addingCircle = true
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "small-icon picker-icon",
                      attrs: { icon: "plus-circle", "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "add-circle" }, [
                      _vm._v("Add Circle")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.additionalParams, function(circle, idx) {
              return _c(
                "md-list-item",
                {
                  key: circle.short,
                  ref: "circleItem-" + circle.short,
                  refInFor: true,
                  class: { "closed-circle": circle.closed },
                  attrs: { "md-expand": "", "md-expanded": circle.expanded },
                  on: {
                    "update:mdExpanded": [
                      function($event) {
                        return _vm.$set(circle, "expanded", $event)
                      },
                      function(expanded) {
                        return _vm.onCircleExpanded(idx, expanded)
                      }
                    ],
                    "update:md-expanded": function($event) {
                      return _vm.$set(circle, "expanded", $event)
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "md-list-item-text community-expand-button"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(circle.name) + "\n\t\t\t\t\t"
                      ),
                      circle.closed
                        ? _c("i", {
                            staticClass: "fa fa-lock circle-status-icon",
                            attrs: {
                              "aria-hidden": "true",
                              title: "Closed circle"
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-list",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: circle.expanded,
                          expression: "circle.expanded"
                        }
                      ],
                      staticClass:
                        "md-layout md-gutter md-field pt-0 mb-0 mlminus-15 col-md-12",
                      attrs: { slot: "md-expand" },
                      slot: "md-expand"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "button-row pt-10 pb-10" },
                        [
                          _c("delete-circle-confirm", {
                            attrs: {
                              circle: circle ? circle : "",
                              community: _vm.community_id,
                              value: "5"
                            },
                            on: { "reload-data": _vm.loadData }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("md-divider"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "md-table-cell-container wizard-buttons m-left-5"
                        },
                        [
                          circle.editing
                            ? [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.saveCircle(idx)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-save small-icon picker-icon"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "md-tooltip",
                                      { attrs: { "md-direction": "left" } },
                                      [_vm._v("Save")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "m-left-10",
                                    on: {
                                      click: function($event) {
                                        return _vm.cancelEdit(idx)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-times picker-icon-danger"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "md-tooltip",
                                      { attrs: { "md-direction": "right" } },
                                      [_vm._v("Cancel")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            : [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.startEdit(idx)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-edit small-icon"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "md-tooltip",
                                      { attrs: { "md-direction": "left" } },
                                      [_vm._v("Edit")]
                                    )
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "button-row pt-10 pb-10" },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "picker-icon picker-name",
                              on: {
                                click: function($event) {
                                  return _vm.toggleCircle(idx)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-times-circle",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.additionalParams[idx].closed
                                      ? "Open circle"
                                      : "Close circle"
                                  ) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("md-list-item", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "circle-detail-row md-layout-item md-layout md-gutter"
                          },
                          [
                            circle.expanded
                              ? _c("circle-tabs", {
                                  key: circle.short,
                                  attrs: {
                                    actionPageOptions: _vm.actionPageOptions,
                                    circle: circle,
                                    community: _vm.community_id,
                                    idx: idx,
                                    limits: _vm.CIRCLE_LIMITS
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da1af3ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da1af3ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Circles.vue
// module id = null
// module chunks = 